import { ReactNode } from 'react';
import { grey } from '@mui/material/colors';
import { DeleteOutline } from '@mui/icons-material';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';

interface Props {
  isEdit: boolean;
  disabled: boolean;
  onRemove: VoidFunction;
  node: ReactNode;
}

export const AttributeCellFields = ({ isEdit, onRemove, disabled, node }: Props) => {
  return (
    <Box sx={{ flex: 1, borderBottom: `1px solid ${grey[300]}`, paddingBottom: '0.5rem' }}>
      <Stack direction="row" gap="0.5rem" width="100%" alignItems="center">
        {node}

        {!isEdit && (
          <Tooltip title="Remove configuration">
            <IconButton
              size="small"
              color="error"
              onClick={onRemove}
              disabled={disabled}
              sx={{ alignSelf: 'flex-start' }}
            >
              <DeleteOutline />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </Box>
  );
};
